import { render, staticRenderFns } from "./DevBlock.vue?vue&type=template&id=7b45156b&scoped=true&"
import script from "./DevBlock.vue?vue&type=script&lang=js&"
export * from "./DevBlock.vue?vue&type=script&lang=js&"
import style0 from "./DevBlock.vue?vue&type=style&index=0&id=7b45156b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b45156b",
  null
  
)

export default component.exports